module.exports = __webpack_public_path__ + "static/img/star.b60f777.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user/star.png
// module id = 1uKS
// module chunks = 66